const breadcrumbs: Record<string, string | Record<string, string>> = {
    campaigns: 'Конкурсы',
    campaign: 'Конкурс',
    campaignSettings: 'Настройки конкурса',
};

export default breadcrumbs;
